import ReactGA from 'react-ga4';

export const initGA = () => {
  if (!process.env.REACT_APP_GA_ID) return;
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
}

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
}
